import { Link, useNavigate } from "react-router-dom"
import { Button } from "./Button"
import MobileMenu from "./MobileMenu"
import "../components/Header.css";
import logo from "../img/Logo/Logo.png";
export default function Header() {
  const navigate = useNavigate()

  const handleLogoClick = () => {
    navigate("/")
    window.scrollTo(0, 0)
  }

  return (
    <header className="header">
      <div className="header-container">
        <img src={logo} alt="Natoshine Logo" className="logo-image"  onClick={handleLogoClick} />
        {/* <button
          onClick={handleLogoClick}
          className="logo-btn"
        >
          <div className="logo-icon">
            <span className="logo-text">N</span>
          </div>
          <span className="brand-name">Natoshine</span>
        </button> */}

        <nav className="nav-desktop">
          <a href="/#products" className="nav-link">
            Products
          </a>
          <a href="/#innovation" className="nav-link">
            Innovation
          </a>
          <Link to="/gallery" className="nav-link">
            Gallery
          </Link>
          <Link to="/about" className="nav-link">
            About Us
          </Link>
          <Link to="/contact" className="nav-link">
            Contact
          </Link>
        </nav>

        {/* <div className="actions-desktop">
          <Button variant="outline">Sign In</Button>
          <Button className="btn-get-started">Get Started</Button>
        </div> */}

        <MobileMenu />
      </div>
    </header>
  )
}

